import * as React from 'react';
import PropTypes from 'prop-types';
import { toReactNode } from '@godaddy/gasket-content-components';
import { withManifest } from '@godaddy/gasket-hcs';
import { componentMap } from './component-map.js';
import './styles.scss';

/**
 * React Component to render the Footer.
 * This component must be present, but may return null if no footer is required.
 *
 * @param {Object} props The props for this component
 * @returns {React.ReactElement} JSX for footer
 */
export function Footer(props) {
  const { footer, belowFooter } = props;

  return (
    <>
      { toReactNode(footer, componentMap) }
      { belowFooter ? belowFooter.map(node => toReactNode(node, componentMap)) : null }
    </>
  );
}

Footer.propTypes = {
  footer: PropTypes.array.isRequired,
  belowFooter: PropTypes.array
};

/**
 * Export Footer with Manifest HOC.
 *
 * @component
 * @public
 */
export default withManifest(Footer);
